import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20 3.324h-1v-2h-2v2H7v-2H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-16c0-1.1-.9-2-2-2zm0 18H4v-11h16v11zm0-13H4v-3h16v3z" fill="#444" /></svg>;